export class MailResendModel {
    mail: string;
}
